import React from 'react'
import { Link } from 'gatsby'

import { Layout, Header, Intro } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            The card component is now the{' '}
            <Link className="link" to="/mt/patterns/attention-card/develop">
              Attention Card
            </Link>{' '}
            pattern. Visit that page for more info.
          </p>
        </Intro>
      </Layout>
    </>
  )
}
